<template>
  <div class="improvement-list">
    <el-card shadow="never">
      <div class="config-section">
        <el-form inline>
          <el-form-item label="年级">
            <el-select v-model="filters.grade" style="width: 110px">
              <el-option v-for="g in availableGrades" :key="g" :label="g" :value="g" />
            </el-select>
          </el-form-item>
          <el-form-item label="基准考试">
            <el-select v-model="filters.baseExamType" placeholder="请选择上一次考试" style="width: 160px" allow-create filterable>
              <el-option-group label="常规考试">
                  <el-option label="月考1" value="monthly_1" />
                  <el-option label="期中考试" value="midterm" />
                  <el-option label="月考2" value="monthly_2" />
                  <el-option label="期末考试" value="final" />
              </el-option-group>
              <el-option-group label="高三模拟">
                  <el-option label="一模" value="mock_1" />
                  <el-option label="二模" value="mock_2" />
                  <el-option label="三模" value="mock_3" />
              </el-option-group>
              <el-option-group label="自定义考试" v-if="dynamicExamTypes.length > 0">
                  <el-option v-for="type in dynamicExamTypes" :key="type" :label="type" :value="type" />
              </el-option-group>
            </el-select>
          </el-form-item>
          <el-form-item label="对比考试">
            <el-select v-model="filters.compareExamType" placeholder="请选择本次考试" style="width: 160px" allow-create filterable>
              <el-option-group label="常规考试">
                  <el-option label="月考1" value="monthly_1" />
                  <el-option label="期中考试" value="midterm" />
                  <el-option label="月考2" value="monthly_2" />
                  <el-option label="期末考试" value="final" />
              </el-option-group>
              <el-option-group label="高三模拟">
                  <el-option label="一模" value="mock_1" />
                  <el-option label="二模" value="mock_2" />
                  <el-option label="三模" value="mock_3" />
              </el-option-group>
              <el-option-group label="自定义考试" v-if="dynamicExamTypes.length > 0">
                  <el-option v-for="type in dynamicExamTypes" :key="type" :label="type" :value="type" />
              </el-option-group>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :icon="DataAnalysis" @click="fetchData" :loading="loading" :disabled="!semesterId || !filters.baseExamType || !filters.compareExamType">
              对比分析
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <div v-if="loading" style="padding: 20px;">
        <el-skeleton :rows="8" animated />
      </div>
      <el-empty v-else-if="!hasData" description="暂无进退步榜单数据，请确保两次考试均有成绩" />
      <div v-else>
        <!-- 进退步表格 -->
        <el-table :data="studentsData" border stripe height="600" style="width: 100%" :header-cell-style="{ background: '#f8fafc', color: '#1e293b', fontWeight: 'bold' }">
          <el-table-column type="index" label="序号" width="60" align="center" fixed />
          <el-table-column prop="student_no" label="学号" width="120" fixed />
          <el-table-column prop="name" label="姓名" width="100" fixed />
          <el-table-column prop="class_name" label="班级" width="100" align="center" />
          
          <el-table-column label="基准分 (上次)" width="120" align="center">
            <template #default="{ row }">{{ row.base_score }}</template>
          </el-table-column>
          <el-table-column label="对比分 (本次)" width="120" align="center">
            <template #default="{ row }">
              <strong>{{ row.compare_score }}</strong>
              <span :class="row.score_diff > 0 ? 'text-green' : (row.score_diff < 0 ? 'text-red' : 'text-gray')" style="font-size: 12px; margin-left: 4px">
                ({{ row.score_diff > 0 ? '+' : '' }}{{ row.score_diff }})
              </span>
            </template>
          </el-table-column>

          <!-- 年级排名对比 -->
          <el-table-column label="年级排名对比" align="center">
            <el-table-column label="上次" width="80" align="center">
              <template #default="{ row }">{{ row.base_grade_rank }}</template>
            </el-table-column>
            <el-table-column label="本次" width="80" align="center">
              <template #default="{ row }"><strong>{{ row.compare_grade_rank }}</strong></template>
            </el-table-column>
            <el-table-column label="年级名次变化" width="120" align="center" sortable sort-by="grade_rank_diff">
              <template #default="{ row }">
                <el-tag :type="row.grade_rank_diff > 0 ? 'success' : (row.grade_rank_diff < 0 ? 'danger' : 'info')" effect="plain">
                  <el-icon v-if="row.grade_rank_diff > 0"><Top /></el-icon>
                  <el-icon v-else-if="row.grade_rank_diff < 0"><Bottom /></el-icon>
                  <el-icon v-else><Minus /></el-icon>
                  {{ Math.abs(row.grade_rank_diff) }}名
                </el-tag>
              </template>
            </el-table-column>
          </el-table-column>

          <!-- 班级排名对比 -->
          <el-table-column label="班级排名对比" align="center">
            <el-table-column label="上次" width="80" align="center">
              <template #default="{ row }">{{ row.base_class_rank }}</template>
            </el-table-column>
            <el-table-column label="本次" width="80" align="center">
              <template #default="{ row }"><strong>{{ row.compare_class_rank }}</strong></template>
            </el-table-column>
            <el-table-column label="班级名次变化" width="120" align="center" sortable sort-by="class_rank_diff">
              <template #default="{ row }">
                <el-tag :type="row.class_rank_diff > 0 ? 'success' : (row.class_rank_diff < 0 ? 'danger' : 'info')" effect="plain">
                  <el-icon v-if="row.class_rank_diff > 0"><Top /></el-icon>
                  <el-icon v-else-if="row.class_rank_diff < 0"><Bottom /></el-icon>
                  <el-icon v-else><Minus /></el-icon>
                  {{ Math.abs(row.class_rank_diff) }}名
                </el-tag>
              </template>
            </el-table-column>
          </el-table-column>

        </el-table>
      </div>
    </el-card>
  </div>
</template>

<script setup>
import { ref, reactive, computed, defineProps } from 'vue'
import { DataAnalysis, Top, Bottom, Minus } from '@element-plus/icons-vue'
import { gradeAnalysisApi } from '@/api'
import { useExamTypes } from '@/utils/useExamTypes'
import { ElMessage } from 'element-plus'

const props = defineProps({
  semesterId: { type: Number, required: false },
  subjectConfigs: { type: Array, required: true },
  availableGrades: { type: Array, default: () => [] }
})

const loading = ref(false)
const filters = reactive({
  grade: props.availableGrades[0] || '',
  baseExamType: null,
  compareExamType: null
})

// 动态考试类型
const { dynamicExamTypes } = useExamTypes(computed(() => props.semesterId))

const studentsData = ref([])
const hasData = computed(() => studentsData.value && studentsData.value.length > 0)

const fetchData = async () => {
  if (!props.semesterId || !filters.baseExamType || !filters.compareExamType) return
  if (filters.baseExamType === filters.compareExamType) {
    ElMessage.warning('基准考试和对比考试不能相同')
    return
  }

  loading.value = true
  try {
    const res = await gradeAnalysisApi.getImprovementAnalysis({
      semester_id: props.semesterId,
      base_exam_type: filters.baseExamType,
      compare_exam_type: filters.compareExamType,
      grade: filters.grade,
      subject_configs: props.subjectConfigs
    })
    
    studentsData.value = res.students || []
    
    if (!hasData.value) {
      ElMessage.warning('该条件下无对比数据')
    }
  } catch (e) {
    console.error(e)
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
.config-section {
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f3f4f6;
}
.text-green { color: #059669; }
.text-red { color: #dc2626; }
.text-gray { color: #9ca3af; }
</style>
